/* eslint-disable jsx-a11y/anchor-is-valid */

import { useCallback } from 'react';
import {
  // BrowserRouter as Router,
  // Switch,
  useLocation,
  Link,
  useHistory,
} from "react-router-dom";
import { useAuth } from "../use-auth";
import { querySubscription } from '../controllers/admin'
import { showAlert } from '../zeta-widget/tools/alert-tool';
const { BACKOFFICE_APP_ID } = require('../configs/constant.json');
const { YOU_ARE_NOT_ADMIN } = require('../configs/msg-th.json');

export function SideBar(props) {
  const auth = useAuth();
  const history = useHistory();
  const location = useLocation();

  const handleSwitchAdmin = useCallback(() => {
    querySubscription(BACKOFFICE_APP_ID, (err, result) => {
      if (err) {
        console.info(err);
        auth.setAdminPrivilege(false);
        return;
      }

      // console.info(result);
      if (!result || result.length === 0) {
        auth.setAdminPrivilege(false);
        showAlert(YOU_ARE_NOT_ADMIN);
        return;
      }

      auth.setAdminPrivilege(true);
      history.push('/admin/home')
    });
  }, [auth, history])
  // console.info(location.pathname);
  if (auth.user && auth.user.adminPrivilege && location.pathname.match(/^\/admin\//i)) {
    return <AdminMenu />
  }

  return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
      {/* Sidebar - Brand */}
      <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/member/home">
        <div className="sidebar-brand-icon">
          <i className="fas fa-cube"></i>
        </div>
        <div className="sidebar-brand-text mx-3">CRK STORE</div>
      </Link>

      {/* Divider */}
      <hr className="sidebar-divider" />

      {/* Dashboard
      <li className="nav-item">
        <a className="nav-link" to="/dashboard">
          <i className="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </a>
      </li>
      
      <hr className="sidebar-divider my-0" />
      */}

      {/* Heading */}
      <div className="sidebar-heading">
        <span className="text-lg">Bills</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <Link className="nav-link" to="/member/bill/pending">
          <i className="fas fa-bullhorn"></i>
          <span>บิลค้างชำระ</span>
        </Link>

        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseActivity"
          aria-expanded="true"
          aria-controls="collapseActivity"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>ประวัติ</span>
        </a>
        <div id="collapseActivity" className="collapse" aria-labelledby="headingActivity" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <Link className="collapse-item" to="/member/bill/3-months">
              ย้อนหลัง 3 เดือน
            </Link>
            <Link className="collapse-item" to="/member/bill">
              สืบค้น
            </Link>
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Subscriptions</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
      <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePlanEntry"
          aria-expanded="true"
          aria-controls="collapsePlanEntry"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>การสมัครใช้งาน</span>
        </a>
        <div
          id="collapsePlanEntry"
          className="collapse"
          aria-labelledby="headingPlanEntry"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">APPS:</h6>
            <Link className="collapse-item" to="/member/subs/active">
              ปัจจุบัน
            </Link>
            <Link className="collapse-item" to="/member/subs/expired">
              หมดอายุ
            </Link>
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Applications</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
      <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseMemberApp"
          aria-expanded="true"
          aria-controls="collapseMemberApp"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>โปรแกรม</span>
        </a>
        <div
          id="collapseMemberApp"
          className="collapse"
          aria-labelledby="headingMemberApp"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">APPS:</h6>
            <Link className="collapse-item" to="/member/apps/all">
              ทั้งหมด
            </Link>
            {/* <Link className="collapse-item" to="/member/apps/free">
              ฟรี
            </Link> */}
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Profile</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseSalesEntry"
          aria-expanded="true"
          aria-controls="collapseSalesEntry"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>ข้อมูลสมาชิก</span>
        </a>
        <div
          id="collapseSalesEntry"
          className="collapse"
          aria-labelledby="headingSalesEntry"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            
            <Link className="collapse-item" to="/member/profile">
              แก้ไขข้อมูล
            </Link>
            <Link className="collapse-item" to="/member/password">
              เปลี่ยนรหัสผ่าน
            </Link>
            {/*
            <Link className="collapse-item" to="/work-search">
              สืบค้นประวัติ
            </Link>
            */}
          </div>
        </div>
      </li>

      {/* Nav Item - Pages Collapse Menu */}
      {/*
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseTwo"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>จัดซื้อ</span>
        </a>
        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">จัดทำเอกสาร:</h6>
            <Link className="collapse-item" to="/purchase-order">
              ใบสั่งซื้อ
            </Link>
          </div>
        </div>
      </li>
      */}
      {/* Nav Item - Pages Collapse Menu */}
      {/*
<li className="nav-item">
    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
        <i className="fas fa-fw fa-cog"></i>
        <span>คลังสินค้า</span>
    </a>
    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
        <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Custom Components:</h6>
            <Link className="collapse-item" href="buttons.html">Buttons</a>
            <Link className="collapse-item" href="cards.html">Cards</a>
        </div>
    </div>
</li>
*/}

      {/* Divider */}
      {/*
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Settings</span>
      </div>
      
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseMaster"
          aria-expanded="true"
          aria-controls="collapseMaster"
        >
          <i className="fas fa-fw fa-clone"></i>
          <span>Masters</span>
        </a>
        <div id="collapseMaster" className="collapse" aria-labelledby="headingMaster" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Master Data:</h6>
            <Link className="collapse-item" to="/spare-part">
              Spare Part
            </Link>
            <Link className="collapse-item" to="/department">Departments</Link>
            <Link className="collapse-item" to="/valid-option">
              Valid Options
            </Link>
          </div>
        </div>
      </li>
      
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseSystem"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>System</span>
        </a>
        <div id="collapseSystem" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">System Configs:</h6>
            <Link className="collapse-item" to="/org-user">Users</Link>
            <Link className="collapse-item" to="/org-info">
              Organization
            </Link>
          </div>
        </div>
      </li>
      */}
      {/* Divider */}
      <hr className="sidebar-divider d-none d-md-block" />

      {/* Sidebar Toggler (Sidebar) */}
      <div className="text-center d-none d-md-inline">
        <button className="rounded-circle border-0" id="sidebarToggle"></button>
      </div>

      <div className="text-center d-md-inline" id="divAdmin">
      <button className="btn btn-sm" id="switchAdmin" onClick={handleSwitchAdmin}>Admin</button>
      </div>
    </ul>
  );
}
/*
function MemberMenu(props) {
  return (

  );
}
*/
function AdminMenu(props) {
  return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
      {/* Sidebar - Brand */}
      <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/member/home">
        <div className="sidebar-brand-icon rotate-n-15">
          <i className="fas fa-meteor"></i>
        </div>
        <div className="sidebar-brand-text mx-3">CRK STORE</div>
      </Link>

      {/* Divider */}
      <hr className="sidebar-divider my-0" />

      {/* Nav Item - Dashboard */}
      <li className="nav-item">
        <a className="nav-link" to="/dashboard">
          <i className="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </a>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      {/* Heading */}
      <div className="sidebar-heading">
        <span className="text-lg">Payments</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <Link className="nav-link" to="/admin/payment/wait-approve">
          <i className="fas fa-bullhorn"></i>
          <span>รออนุมัติ เงินรับ</span>
        </Link>
        
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseActivity"
          aria-expanded="true"
          aria-controls="collapseActivity"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>เงินรับเข้า</span>
        </a>
        <div id="collapseActivity" className="collapse" aria-labelledby="headingActivity" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <Link className="collapse-item" to="/admin/payment">
              สืบค้น
            </Link>
            {/* <Link className="collapse-item" to="/contact">
              รายชื่อผู้ติดต่อ
            </a> */}
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Bills</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
      <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePlanEntry"
          aria-expanded="true"
          aria-controls="collapsePlanEntry"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>ใบแจ้งหนี้</span>
        </a>
        <div
          id="collapsePlanEntry"
          className="collapse"
          aria-labelledby="headingPlanEntry"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">รอดำเนินการ:</h6>
            <Link className="collapse-item" to="/admin/bill/wait-approve">
              รออนุมัติ
            </Link>
            <Link className="collapse-item" to="/admin/bill/over-due">
              เกินกำหนดชำระ
            </Link>
          </div>
        </div>
      </li>

      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Members</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseSalesEntry"
          aria-expanded="true"
          aria-controls="collapseSalesEntry"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>การสั่งซื้อ</span>
        </a>
        <div
          id="collapseSalesEntry"
          className="collapse"
          aria-labelledby="headingSalesEntry"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">ปัจจุบัน:</h6>
            <Link className="collapse-item" to="/admin/subs/pending">
              รอชำระเงิน
            </Link>
            <Link className="collapse-item" to="/admin/subs/expired">
              หมดอายุ
            </Link>
{/*             
            <Link className="collapse-item" to="/work-report/in-progress">
              ระหว่างผลิต
            </Link>
            <Link className="collapse-item" to="/work-report/near-due">
              ใกล้ถึงกำหนด
            </Link> */}

            <h6 className="collapse-header">ทั้งหมด:</h6>
            <Link className="collapse-item" to="/admin/subs">
              สืบค้น
            </Link>
            {/*
            <Link className="collapse-item" to="/work-history/contact">
              สรุปยอดลูกค้า
            </Link>
            <Link className="collapse-item" to="/work-search">
              สืบค้นประวัติ
            </Link>
            */}
          </div>
        </div>
      </li>

      {/* Nav Item - Pages Collapse Menu */}
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseTwo"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>ข้อมูลสมาชิก</span>
        </a>
        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">ข้อมูลลงทะเบียน:</h6>
            <Link className="collapse-item" to="/admin/member">
              สืบค้น
            </Link>
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Applications</span>
      </div>

      {/* Nav Item - Pages Collapse Menu */}
      
      <li className="nav-item">
          <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseApp" aria-expanded="true" aria-controls="collapseApp">
              <i className="fas fa-fw fa-cog"></i>
              <span>โปรแกรมใช้งาน</span>
          </a>
          <div id="collapseApp" className="collapse" aria-labelledby="headingApp" data-parent="#accordionSidebar">
              <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Registerd Apps:</h6>
                  <Link className="collapse-item" to="/admin/app">สืบค้น</Link>
                  {/* <Link className="collapse-item" href="cards.html">Cards</Link> */}
              </div>
          </div>
      </li>


      {/* Divider */}
      <hr className="sidebar-divider" />

      <div className="sidebar-heading">
        <span className="text-lg">Settings</span>
      </div>
      {/*
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseMaster"
          aria-expanded="true"
          aria-controls="collapseMaster"
        >
          <i className="fas fa-fw fa-clone"></i>
          <span>Masters</span>
        </a>
        <div id="collapseMaster" className="collapse" aria-labelledby="headingMaster" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Master Data:</h6>
            <Link className="collapse-item" to="/spare-part">
              Spare Part
            </a>
            <Link className="collapse-item" to="/department">Departments</a>
            <Link className="collapse-item" to="/valid-option">
              Valid Options
            </a>
          </div>
        </div>
      </li>
      */}
      <li className="nav-item">
        <a
          className="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseSystem"
          aria-expanded="true"
          aria-controls="collapseTwo"
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>System</span>
        </a>
        <div id="collapseSystem" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">System Configs:</h6>
            <Link className="collapse-item" to="/org-user">Users</Link>
            {/*
            <Link className="collapse-item" to="/employee">
              Employees
            </a>
            <Link className="collapse-item" to="/system-config">
              System Values
            </a>
            <Link className="collapse-item" to="/valid-option">
              Valid Options
            </a>
            <Link className="collapse-item" to="/user-role">
              User Role
            </a>
            */}
            <Link className="collapse-item" to="/org-info">
              Organization
            </Link>
          </div>
        </div>
      </li>

      {/* Divider */}
      <hr className="sidebar-divider d-none d-md-block" />

      {/* Sidebar Toggler (Sidebar) */}
      <div className="text-center d-none d-md-inline">
        <button className="rounded-circle border-0" id="sidebarToggle"></button>
      </div>
    </ul>
  );
}